<template>
    <div class="app-layout">
        <!-- 头部 -->
        <HeadPage></HeadPage>
        <!-- 中间 -->
        <div class="content">
            <transition name="page-transition">
                <router-view></router-view>
            </transition>
        </div>
        <!-- 底部 -->
        <BottomPage></BottomPage>
    </div>
</template>
  
<script>
import HeadPage from './components/head'
import BottomPage from './components/bottom'
export default {
    name: 'BasicLayout',
    components: {
        HeadPage,
        BottomPage
    },
    data() {
        return {

        }
    },
    computed: {

    },
    created() {

    },
    mounted() {

    },
    methods: {

    }
}
</script>
  
<style lang="less"></style>
  